import { render, staticRenderFns } from "./WAR-ColumnAlpha.vue?vue&type=template&id=59dcd193&"
import script from "./WAR-ColumnAlpha.vue?vue&type=script&lang=js&"
export * from "./WAR-ColumnAlpha.vue?vue&type=script&lang=js&"
import style0 from "./WAR-ColumnAlpha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports